import { render } from "./App.vue?vue&type=template&id=f2d5b4a0&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=f2d5b4a0&scoped=true&lang=scss"
import "./App.vue?vue&type=style&index=1&id=f2d5b4a0&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2d5b4a0"]])

export default __exports__